import { Pressed } from 'libs/ui';
import { styled } from 'libs/ui/styled';
import { Colors } from 'libs/ui/theme';

export const MenuBurgerPressedStyled = styled(Pressed)(() => ({
  padding: '4px 0',

  ':hover': {
    color: Colors.hover,
  },
}));
